namespace SP {
    export interface PurchaseOrderLineInfo {
        id: string;
        sku: string,
        qty: number,
        loc: string,
        externalId: string,
        price: number,
        undeliveredQty: number,
        deliveredQty: number,
        beeingDeliveredQty: number,
        itemTotalIncommingAllOrders: number,
        itemInfo: ItemInfo
    }
}